import React, { useState } from 'react';
import { theme } from '../theme';
import Icons from './Icons';

// ---------------------------------------------------------------------------
// History list (sidebar) — hover-reveal delete + inline confirmation,
// matches the Saved Queries pattern.
// ---------------------------------------------------------------------------
export default function HistoryList({ history, onSelect, onDelete }) {
  const [confirmDeleteTs, setConfirmDeleteTs] = useState(null);

  if (!history || history.length === 0) {
    return (
      <div style={{ padding: '16px', textAlign: 'center', color: theme.textMuted, fontSize: '12px' }}>
        No queries run yet this session.
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      {history.map((h, i) => {
        const isConfirming = confirmDeleteTs === h.timestamp;
        const snippet = (h.sql || '').substring(0, 40).trim();
        return (
          <div
            key={i}
            style={{
              position: 'relative', padding: '8px 10px', borderRadius: '6px',
              cursor: isConfirming ? 'default' : 'pointer',
              transition: 'background 0.15s',
              background: isConfirming ? `${theme.danger}0d` : 'transparent',
            }}
            onClick={() => { if (!isConfirming) onSelect(h); }}
            onMouseEnter={(e) => {
              if (!isConfirming) e.currentTarget.style.background = theme.surfaceHover;
              const btn = e.currentTarget.querySelector('.del-btn');
              if (btn) btn.style.opacity = '1';
            }}
            onMouseLeave={(e) => {
              if (!isConfirming) e.currentTarget.style.background = 'transparent';
              const btn = e.currentTarget.querySelector('.del-btn');
              if (btn) btn.style.opacity = '0';
            }}
          >
            {isConfirming ? (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px' }}>
                <span style={{
                  fontSize: '12px', color: theme.danger, flex: 1, minWidth: 0,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  fontFamily: 'monospace',
                }}>
                  {snippet ? `Delete "${snippet}${h.sql.length > 40 ? '…' : ''}"?` : 'Delete this entry?'}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(h.timestamp);
                      setConfirmDeleteTs(null);
                    }}
                    title="Confirm delete"
                    style={{
                      background: theme.danger, border: 'none', color: '#fff',
                      cursor: 'pointer', padding: '2px 7px', borderRadius: '3px',
                      fontSize: '11px', fontWeight: 600,
                    }}
                  >
                    Delete
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); setConfirmDeleteTs(null); }}
                    title="Cancel"
                    style={{
                      background: 'none', border: `1px solid ${theme.border}`,
                      color: theme.textMuted, cursor: 'pointer',
                      padding: '2px 6px', borderRadius: '3px', fontSize: '11px',
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div style={{
                  fontSize: '12px', fontFamily: 'monospace', color: theme.text,
                  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  paddingRight: '20px',
                }}>
                  {h.sql?.substring(0, 60) || '(empty)'}
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '3px', fontSize: '11px', color: theme.textMuted }}>
                  <span>{h.rowCount} rows</span>
                  <span>{new Date(h.timestamp).toLocaleTimeString()}</span>
                </div>
                {onDelete && (
                  <button
                    className="del-btn"
                    onClick={(e) => { e.stopPropagation(); setConfirmDeleteTs(h.timestamp); }}
                    style={{
                      position: 'absolute', top: '8px', right: '6px',
                      background: 'none', border: 'none', color: theme.textMuted,
                      cursor: 'pointer', padding: '2px', opacity: 0,
                      transition: 'opacity 0.15s, color 0.15s',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = theme.danger; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = theme.textMuted; }}
                    title="Remove from history"
                  >
                    <Icons.X />
                  </button>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
